module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-alert', {
    attrs: {
      "show-icon": "",
      "type": "info1",
      "title": "Please Note",
      "description": "Searching for 'description' is Case Senstive"
    }
  }), _vm._v(" "), _c('data-table', {
    ref: "auditLogs",
    attrs: {
      "title": "Sytem Audit Logs",
      "title-heading": "h5",
      "url": "/view/logs",
      "fields": _vm.fields,
      "sort-field": "updated_at|desc",
      "search-placeholder": "Category, Description, User...",
      "table-ref": "auditLogsDataTable"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f02c019a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/AuditLogs.vue
// module id = 1652
// module chunks = 0